import type { SVGProps } from "react";

/** Flag of Italy, drawn in a 4:3 box shared by every flag in this folder. */
export function FlagIt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 60 45" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="20" height="45" fill="#008c45" />
      <rect x="20" width="20" height="45" fill="#f4f5f0" />
      <rect x="40" width="20" height="45" fill="#cd212a" />
    </svg>
  );
}
